import { Box, Divider, Flex, Grid, Label, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { t } from 'services/localization';

import { LineItemPaymentQuoteProps } from './LineItemPaymentQuote.types';

export const LineItemPaymentQuote = memo<LineItemPaymentQuoteProps>((props) => {
    const { formattedAmount, formattedFee, formattedFxRate, conversionDate, paymentDate, arriveNotice } = props;

    return (
        <Box color='midnight20' radius='small' spacing='16' height='max-content'>
            <Grid gap={8}>
                <div>
                    <Label size='medium'>{t('to_be_paid_1')}</Label>

                    <Text font='label' fontSize='medium' fontWeight='bold'>
                        {formattedAmount}
                    </Text>
                </div>

                <Flex spacing='8'>
                    <Label spacing='0'>{t('includes_fee')}</Label>

                    <Text font='label' fontSize='xsmall'>
                        {formattedFee}
                    </Text>
                </Flex>

                {formattedFxRate && (
                    <>
                        <Divider />

                        <Flex spacing='8'>
                            <Label spacing='0'>{t('your_fx_rate')}</Label>

                            <Text font='label' fontSize='xsmall'>
                                {formattedFxRate}
                            </Text>
                        </Flex>

                        <Flex spacing='8'>
                            <Label spacing='0'>{t('conversion_date')}</Label>

                            <Text font='label' fontSize='xsmall'>
                                {conversionDate}
                            </Text>
                        </Flex>
                    </>
                )}

                <Divider />

                <Flex spacing='8'>
                    <Label spacing='0'>{t('payment_date_1')}</Label>

                    <Text font='label' fontSize='xsmall'>
                        {paymentDate}
                    </Text>
                </Flex>

                <Text font='label' fontSize='xsmall' color='midnight70'>
                    {arriveNotice}
                </Text>
            </Grid>
        </Box>
    );
});

LineItemPaymentQuote.displayName = 'LineItemPaymentQuote';
